import type { IconSvgObject } from './types';

const ChevronsDownIcon: IconSvgObject = [
  ["path", { d: "M7 13L12 18L17 13", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M7 6L12 11L17 6", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default ChevronsDownIcon;
